import "./style/home.scss"

import PathNames from "@app/const/PathNames"
import { RootState } from "@app/types"
import React from "react"
import { useSelector } from "react-redux"

// Components
import BundleSection from "@modules/bundles/BundleSection"
import EditorialContent from "@modules/editorial-content/EditorialContent"
import ProductListSkeleton from "@modules/products/ProductListSkeleton"
import Container, { Content } from "@modules/shared/Container"
import ScrollView from "@modules/shared/ScrollView"
import Spinner from "@ng-mw/reol/components/Spinner"
import { HandoverPickerTypeAndTime } from "@ng-mw/shared-react-components/handover-picker"
import { ProductView } from "@ng-mw/shared-react-components/lazy-loaders"
import GlobalMaintenanceMessage from "./GlobalMaintenanceMessage"
import HomeFooter from "./HomeFooter"
import HomeVersions from "./HomeVersions"
import TopBanner from "./TopBanner"
import UltraCompactWeekMenu from "../weekmenu/UltraCompactWeekMenu"
import { isDebugMode } from "@app/helpers"
import { trackClickSeeMoreRecipes, useAutomaticTrackingData } from "@ng-mw/shared-react-components"

const productViewId = "home-popular"

const HomeSkeleton = () => {
    const productView = useSelector((state: RootState) => state.productView[productViewId])
    const isDebugModeActive = isDebugMode()

    const automaticTrackingData = useAutomaticTrackingData()
    const trackSeeMore = () => {
        trackClickSeeMoreRecipes(automaticTrackingData)
    }

    return (
        <ScrollView className="app-home">
            <div className="app-home__slow-loading-message">
                <p>Laster brukerdata...</p>
                <Spinner />
                {isDebugModeActive ? (
                    <p>DEBUG: Dvs. vi venter på at native wrapperen skal svare med token</p>
                ) : null}
            </div>

            <div className="app-home__top-section">
                <div className="app-home__handover-picker">
                    <h2 className="ws-visually-hidden">Levering og tid</h2>
                    <HandoverPickerTypeAndTime />
                </div>
                <GlobalMaintenanceMessage />
                <TopBanner />
            </div>

            <BundleSection campaignAdminTag="app_bundle_1" />

            <Container
                title="Ukemeny fra våre kokker"
                linkText="Se flere oppskrifter"
                onClick={trackSeeMore}
                to={PathNames.RecipesHome}
                content={Content.FullWidth}
                headingLevel={2}
            >
                <UltraCompactWeekMenu />
            </Container>

            <Container
                title="Våre bestselgere"
                linkText="Se alle"
                to={PathNames.Search}
                from="Varer link. Home page"
                headingLevel={2}
            >
                <ProductListSkeleton
                    isLoading={!!productView?.loading}
                    productCount={5}
                >
                    <div className="app-home__products-list">
                        <ProductView
                            id={productViewId}
                            showFilter={false}
                            hideCategoriesFilter
                            perPage={4}
                            spinnerless
                            headingless
                            emptyResultMessage={() => (
                                <div className="ws-product-view__empty-result">
                                    <strong>Ojsann</strong>, klarte ikke å laste inn varene akkurat
                                    nå.
                                </div>
                            )}
                            list="Hjem-side: Våre bestselgere"
                        />
                    </div>
                </ProductListSkeleton>
            </Container>

            <BundleSection campaignAdminTag="app_bundle_2" />
            <EditorialContent />
            <HomeFooter />
            <HomeVersions />
        </ScrollView>
    )
}

export default HomeSkeleton
